<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <public-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-lg mx-auto">
                <h3 class="font-bold text-2xl mb-8">{{ $t("loginToInvestorAccount") }}</h3>
                <form autocomplete="off">
                    <k-input
                            class="mb-4"
                            id="email"
                            label="Email"
                            v-model="form.email"
                            :field-errors="validation.fieldErrors"/>
                    <k-input
                            class="mb-2"
                            id="password"
                            label="Password"
                            v-model="form.password"
                            type="password"
                            :field-errors="validation.fieldErrors"/>
                    <div class="text-sm">
                        <router-link :to="'forgot-password'" class="text-primary-500 hover:text-primary-600">
                            {{ $t("forgotPassword") }}
                        </router-link>
                    </div>
                    <div v-if="fieldError('login')"
                         class="text-red-500 text-xs italic mt-3">
                        {{ $t("loginFailed") }}
                    </div>
                    <div class="mt-6">
                        <k-button @click.native.prevent="onSubmit">
                            {{ $t("login") }}
                        </k-button>
                    </div>
                </form>
                <div class="text-sm mt-3">{{ $t("dontHaveAccount") }}
                    <a href="#" @click.prevent="registrationRedirectToReact" class="text-primary-500 hover:text-primary-600">{{ $t("register") }}</a>
                </div>
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
import PublicHeader from '@investor/components/PublicHeader';

export default {
        components: {
            PublicHeader
        },
        data() {
            return {
                loading: false,
                form: {
                    email: "",
                    password: ""
                },
                validation: {
                    fieldErrors: {}
                }
            }
        },
        async mounted() {
            if (!this.$isProd) {
                this.form.email = "investor@mail.com"
                this.form.password = "Test1234"
            }
            if (this.$authToken()) {
                await this.$fetchInvestorProfile();
                await this.$routeInvestor();
            }
        },
        methods: {
            async onSubmit() {
                this.validation = {
                    fieldErrors: {}
                };
                try {
                    const resp = await this.$post('public/login', this.form);
                    this.$trackGAEvent('login', 'loginAccount');
                    if (resp.twoFactorAuthenticationRequired) {
                        await this.$router.push(`/authentication`);
                    } else {
                        await this.$login(resp.token);
                    }
                } catch (error) {
                    console.error(error)
                    if (error.response && error.response.status === 400) {
                        this.validation = error.response.data;
                        this.$scrollToErrorField();
                    }
                }
            },
            async registrationRedirectToReact() {
                if (!this.$isProd) {
                    window.location.href = 'https://staging.kilde.sg/register';
                } else {
                    window.location.href = 'https://app.kilde.sg/register';
                }
            },
            fieldError(field) {
                return this.validation.fieldErrors[field];
            },
        }
    }
</script>
